import IconArrowRight from '@/assets/icons/drawer-icons/icon-arrow-right.svg';
import IconHeart from '@/assets/icons/icon-heart.svg';
import MenuIcon from '@/assets/icons/icon-menu.svg';
import IconClose from '@/assets/icons/icon-round-close.svg';
import IconCall from '@/assets/icons/main-page/icon-call.svg';
import IconCompare from '@/assets/icons/main-page/icon-compare-burger.svg';
import { CustomCitiesSelect } from '@/components';
import { MenuDetailsFragment, useUserFavoritesQuery } from '@/graphql';
import { Link, usePathname, useRouter } from '@/i18n/navigation';
import comparisonStore from '@/zustand/comparison';
import { favoritesStore } from '@/zustand/favourite';
import { useGuestStore } from '@/zustand/guestStore';
import useCatalogStore from '@/zustand/useOpenCatalog';
import useUserStore from '@/zustand/useUser';
import { useLocale, useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useState, useTransition } from 'react';
import { useWindowSize } from 'react-use';
import { Button, Drawer } from 'rsuite';
import DrawerContent from '../../drawer-content';
import styles from './drawerContent.module.scss';

const DrawerMobile = ({
  open: openDrawer,
  setOpen: setOpenDrawer,
  menu,
  loading,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  menu: MenuDetailsFragment | null | undefined;
  loading: boolean;
}) => {
  const locale = useLocale();
  const [switchLanguage, setSwitchLanguage] = useState<string>(locale);
  const favorite = favoritesStore(e => e.favorites);
  const comparison = comparisonStore(e => e.comparison);
  const { open, setOpen } = useCatalogStore();
  const [openCatalog, setOpenCatalog] = useState(false);
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = Boolean(userData?.id);
  const favorites = favoritesStore(e => e.favorites);
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const t = useTranslations('General');
  const guestFavoriteListArray = useGuestStore(state => state.favoriteList);
  const {
    data: favoriteData,
    loading: isFavoriteDataLoading,
    refetch: refetchFavoriteData,
  } = useUserFavoritesQuery({
    variables: { first: 10 },
    context: {
      requiresAuth: true,
    },
  });
  const { width } = useWindowSize();

  const handleCloseButton = () => {
    setOpenDrawer(false);
  };

  const handleSwitchLanguage = (language: string) => {
    setSwitchLanguage(language);
    isPending && console.log('Pending...');
    startTransition(() => {
      router.replace(
        // @ts-expect-error -- TypeScript will validate that only known `params`
        { pathname, params },
        { locale: language }
      );
    });
  };

  const openCatalogDrawer = () => {
    setOpenCatalog(true);
    setOpenDrawer(false);
  };
  const closeCatalogDrawer = () => {
    setOpenCatalog(false);
  };

  return (
    <div>
      <Drawer
        size={`${
          width <= 1210
            ? 'calc(100% - 0px'
            : width <= 1435
              ? 'calc(100% - 268px'
              : 'calc(100% - 490px'
        })`}
        placement="left"
        backdrop="static"
        open={openDrawer}
        closeButton={false}
      >
        <Drawer.Body style={{ padding: '0' }}>
          <div className={styles.content}>
            <div className={styles.mobileClose}>
              <div className={styles.delivery}>
                <div className={styles.city}>
                  <CustomCitiesSelect />
                </div>
                <div className={styles.deliveryInfo}>{t('delivery')}</div>
              </div>
              <button
                type="button"
                className={styles.drawer__closeButton}
                onClick={handleCloseButton}
              >
                <IconClose />
              </button>
            </div>
            <div className={styles.callSection}>
              <div className={styles.phoneNumber}>
                +998 (71) 200 31 00
                <span className={styles.schedule}>{t('schedule')}</span>
              </div>
              <a
                href="tel:+998712003100"
                className={styles.callBtn}
                type="button"
              >
                <IconCall />
                {t('call')}
              </a>
            </div>
            <div className={styles.langWrapper}>
              <div className={styles.languageSwitch}>
                <button
                  type="button"
                  onClick={() => handleSwitchLanguage('ru')}
                  className={`${styles.lang} ${switchLanguage === 'ru' && styles.active}`}
                >
                  Рус
                </button>
                <button
                  type="button"
                  onClick={() => handleSwitchLanguage('uz')}
                  className={`${styles.lang} ${switchLanguage === 'uz' && styles.active}`}
                >
                  O’z
                </button>
              </div>
            </div>
            <div className={styles.navLinks}>
              {menu?.items?.map(item => (
                <Link
                  href={item.url || '#'}
                  className={styles.link}
                  onClick={handleCloseButton}
                  key={item.id}
                >
                  <div className={styles.title}>{item.name}</div>
                  <IconArrowRight />
                </Link>
              ))}
            </div>
            <div className={styles.navLinks}>
              <Link
                href={'/pages/comparison'}
                onClick={handleCloseButton}
                className={styles.link}
              >
                <div className={styles.title}>
                  <div className={styles.icon}>
                    <IconCompare />
                  </div>{' '}
                  {t('comparison')}
                  {comparison?.length > 0 && (
                    <span className={styles.count}>{comparison?.length}</span>
                  )}
                </div>
                <IconArrowRight />
              </Link>
              <Link
                href={'/pages/favorites'}
                onClick={handleCloseButton}
                className={styles.link}
              >
                <div className={styles.title}>
                  <div className={styles.icon}>
                    <IconHeart />
                  </div>{' '}
                  {t('favorites')}
                  {(isLoggedIn
                    ? (favoriteData?.me?.favorites?.edges?.length ?? 0) > 0
                    : guestFavoriteListArray?.length > 0) && (
                    <span className={styles.headerBottom__cartCount}>
                      {isLoggedIn
                        ? favoriteData?.me?.favorites?.edges?.length
                        : guestFavoriteListArray?.length}
                    </span>
                  )}
                </div>
                <IconArrowRight />
              </Link>
            </div>
            <div className={styles.btn}>
              <Button
                type="button"
                className={styles.catalogButton}
                onClick={openCatalogDrawer}
              >
                <MenuIcon />
                <span className={styles.title}>{t('catalog-products')}</span>
              </Button>
            </div>
          </div>
        </Drawer.Body>
      </Drawer>
      <Drawer
        size={`${
          width <= 767
            ? 'calc(100% - 0px'
            : width <= 1241
              ? 'calc(100% - 50px'
              : width <= 1510
                ? 'calc(100% - 100px'
                : width <= 1750
                  ? 'calc(100% - 258px'
                  : 'calc(100% - 490px'
        })`}
        placement="left"
        onClose={closeCatalogDrawer}
        open={openCatalog}
        closeButton={false}
      >
        <Drawer.Body style={{ padding: '0' }}>
          <div style={{ height: '100%' }}>
            <DrawerContent closeButton={closeCatalogDrawer} />
          </div>
        </Drawer.Body>
      </Drawer>
    </div>
  );
};

export default DrawerMobile;
